import React, { useEffect, useState } from "react";
import { formatLocalTime, formatTime, toBool } from "../../JS/utility";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import { popupOpenClose } from "../../../action/action";
import { CMSPath } from "../../../config/constant";
import { scrollToTop } from "../../../JS/scrollToTop";
import { ClientInfoLS_Key } from ".";
import { isFirstReservation } from "./helpers";



const Event6_AdditionalInfo = (props) => {

    const { t } = props;

    const handleBack = () => {
        props.back();
    }

    const handleNext = () => {
        let emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

        if (isFirstReservation()) {
            if (props.additionalInfo.firstName == "") {
                props.popupOpenClose(true, t('events.enter_firstName'))
                return;
            }
        }
        if (isFirstReservation()) {
            if (props.additionalInfo.lastName == "") {
                props.popupOpenClose(true, t('events.enter_lastName'))
                return;
            }
        }
        if (isFirstReservation() || props.myReservations[0].phone_number=='') {
            if (props.additionalInfo.phoneNumber == "" ) {
                props.popupOpenClose(true, t('events.enter_phoneNumber'))
                return;
            }
        }

        if (isFirstReservation()) {
            if (props.additionalInfo.email == "") {
                props.popupOpenClose(true, t('events.enter_email'))
                return;
            }
            if (!emailRegex.test(props.additionalInfo.email)) {
                props.popupOpenClose(true, "Please enter a valid email");
                return;
            }
        }




        console.log('customerdetail', props.additionalInfo)
        props.next()
    }

    useEffect(() => {
        scrollToTop();
    }, [])

    return (
        <>
            <header className="inner-pages w-footer subpages">
                <a className="button-back" onClick={props.back}></a>
                <div className="heading align-center">
                    <div class="splash-brand">
                        <img src={`${CMSPath}${props.logo}`} />
                    </div>
                </div>
            </header>
            <section class="widgets spa-listing spa-details">

                <div class="widget-header">
                    {props.currentWidgetObj.widgetHeaderImageUrl &&
                        <div class="widget-header-img">
                            <img src={`${CMSPath}${props.currentWidgetObj.widgetHeaderImageUrl}`} alt={props.currentWidgetObj.displayName} />
                        </div>
                    }
                    <div class="widget-header-title">{t('events.heading6')}</div>
                    {/* <div>{t(`resReservationV2.heading2a`)}</div> */}
                </div>

                <div class="widgets">
                    <div class="row margin-bottom-2">
                        <div class="row">
                            <div class="col">

                                <div class="detail-body stay-body">
                                    <form>

                                        { isFirstReservation()
                                            &&
                                            <div class="form-row">
                                                <p class="heading">{t('events.firstName')} <span style={{ color: "red" }}>*</span></p>
                                                <input type="text" value={props.additionalInfo.firstName} onChange={(e) => props.setAdditionalInfo({ ...props.additionalInfo, firstName: e.target.value })} placeholder={t('events.firstName_placeholder')} />
                                            </div>}


                                        { isFirstReservation()
                                            &&
                                            <div class="form-row">
                                                <p class="heading">{t('events.lastName')} <span style={{ color: "red" }}>*</span></p>
                                                <input type="text" value={props.additionalInfo.lastName} 
                                                onChange={(e) => props.setAdditionalInfo({ ...props.additionalInfo, lastName: e.target.value })}
                                                 placeholder={t('events.lastName_placeholder')} 
                                                 />
                                            </div>}

                                            
                                            {
                                                <div class="form-row">
                                                    <p class="heading">{t('events.email')} <span style={{ color: "red" }}>*</span></p>
                                                    <input type="text" disabled={!(isFirstReservation())} value={isFirstReservation() 
                                                        ? props.additionalInfo.email
                                                        :(props.myReservations && props.myReservations.length>0 && props.myReservations[0] &&  props.myReservations[0].email || '')
                                                            } onChange={(e) => props.setAdditionalInfo({ ...props.additionalInfo, email: e.target.value })} placeholder={t('events.email_placeholder')} />
                                                </div>}



                                        { (isFirstReservation() || props.myReservations[0].phone_number=='')
                                        &&
                                        <div class="form-row">
                                            <p class="heading">{t('events.phone_number')} <span style={{ color: "red" }}>*</span></p>
                                            <input type="tel" value={props.additionalInfo.phoneNumber}
                                            onChange={(e) => props.setAdditionalInfo({ ...props.additionalInfo, phoneNumber: e.target.value })}
                                            placeholder={t('events.phoneNumber_placeholder')}
                                                />
                                        </div>}




                                        <div class="form-row">
                                            <p class="heading">{t('events.guestComment')}</p>
                                            <textarea rows="5" value={props.additionalInfo.guestComment} onChange={(e) => props.setAdditionalInfo({ ...props.additionalInfo, guestComment: e.target.value })} placeholder={t('events.guestComment_placeholder')}></textarea>
                                        </div>

                                    </form>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="form-controls">
                                <button onClick={handleNext}>{t('events.continue')}</button>
                                <button onClick={handleBack}>{t('events.back')}</button>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

const mapStateToProps = state => {
    return {
        installedAppVersion: state.store.installedAppVersion,
        installedAppBuildNo: state.store.installedAppBuildNo,
        timeFormat: state.store.home.clientConfig.extraConfigParam && state.store.home.clientConfig.extraConfigParam.TIME_FORMAT_MERIDIEM,
        currentHomePage: state.store2.currentHomePage,
        currentWidgetObj: state.store.sideNavBar.currentWidget,
        guestDetail: state.store.home.guestDetails,
        serverTimeDate: state.store.home.serverTimeDate.date,
        menuColor: state.store.home.MenuColor,
        dateFormat: state.store.home.clientConfig.extraConfigParam
            ? state.store.home.clientConfig.extraConfigParam.DATE_FORMAT : "",
        guestIsLoggedIn: state.store2.guestIsLoggedIn,
        currentWidgets: state.store.sideNavBar.currentWidget,
        gmtOffset: state.store.home.serverTimeDate.gmtOffset,
        logo: state.store.home.currentDuration.brandingInfo ?
        state.store.home.currentDuration.brandingInfo.hotelLogoImageUrl : "",
   
       }
}

export default connect(mapStateToProps, { popupOpenClose })(withTranslation('translations')(Event6_AdditionalInfo));